export default "__VITE_ASSET__D1qn0HmX__"